<template>
  <div class="page-tree-wrapper">
    <!--<div v-for="(item,index) in list" :key="index">
            <div class="tree-menu-item" @click.stop="handleTreeMenu(item)">
                <i v-if="item.level!=1" class="el-icon-video-play collapse-icon"></i>
                <span v-else style="margin-right:5px;">第{{index+1}}章</span>
                {{item.title}}--{{item.id}}
            </div>
            <TreeMenus :list="item.children" :style="'margin-left:'+15*(item.level)+'px'" 
            @menu="getMenu" @numVal="getNumVal"></TreeMenus>
        </div>-->
    <el-tree ref="mylist" :data="list" :props="defaultProps" :render-content="renderContent" default-expand-all
      :current-node-key="currentKey" highlight-current @node-click="handleTreeMenu" node-key="id"
      :default-expanded-keys="defaultExpandedKeys"></el-tree>
  </div>
</template>

<script>
export default {
  name: "TreeMenus",
  props: {
    name: String,
    list: Array,
    defaultExpandedKeys: Array,
    currentKey: Number,
  },
  components: {},
  data() {
    return {
      activeMenu: {},
      treeData: [],
      defaultProps: {
        children: "children",
        label: "title",
      },
    };
  },
  mounted() { },
  updated() {
    if (this.currentKey) {
      this.$refs.mylist.setCurrentKey(this.currentKey);
    }
  },
  methods: {
    handleTreeMenu(row) {
      this.activeMenu = row;
      this.$emit("numVal", row.level);
      this.$emit("menu", JSON.stringify(row));
    },
    getMenu(row) {
      this.$emit("menu", JSON.stringify(row));
    },
    getNumVal(num) {
      this.$emit("numVal", num);
    },
    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span class={`el-tree-node__labels level-${node.level}`}>{node.label}</span>
          <i class="el-icon-edit-outline free-audition"
            v-show={node.data.whetherOpenTest === 1}
            onclick={(e) => this.instantTest(e, node)}></i>
          {/* <el-button size='mini'
            v-show={node.data.whetherOpenTest === 1}
            class="free-audition"
            onclick={(e) => this.instantTest(e, node)}
          >
            随堂测
          </el-button> */}
        </span>
      );
    },
    instantTest(e, node) {
      // console.log(node, this.name);
      let testInfo = {
        title: this.name,
        title2: node.label,
      }
      window.localStorage.setItem("testInfo", JSON.stringify(testInfo))
      this.$router.push(`/instantTest/${node.data.id}`);
    },
  },
};
</script>

<style lang="less" scoped>
// /deep/ .el-tree-node__label:hover {
//   background-color: rgb(190, 190, 248);
// }

::v-deep .el-tree-node__labels {
  display: inline-block;

  // width: 320px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.collapse-icon {
  font-size: 25px;
  display: inline-block;
  color: #fff;
  margin-right: 5px;
}

.tree-menu-item-active {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #2b85e4;
}

.tree-menu-item {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.catalogue-collapse {
  background: #353938 !important;
  color: #fff !important;
}

.page-tree {
  background: #353938 !important;
  color: #fff !important;
  // font-size: 20px !important;
}

.el-tree {
  background: #353938 !important;
  color: #fff !important;
  //  font-size: 20px !important;
}

.el-tree-node {
  background: #353938 !important;
  color: #fff !important;
  // font-size: 20px !important;
}

.el-tree-node:hover {
  background: #353938 !important;
  color: #fff !important;
}

.el-tree-node__content:hover {
  background: #353938 !important;
  color: #fff !important;
  opacity: 0.8 !important;
}

.el-tree-node:focus>.el-tree-node__content {
  background-color: #353938 !important;
  color: #2b85e4 !important;
}

.el-tree-node__content:hover {
  background-color: #353938 !important;
}

.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #353938 !important;
  color: #2b85e4 !important;
}

.el-tree-node__content {
  //font-size: 20px !important;
}

/deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  color: #54a2f5 !important;
}

/deep/ .free-audition {
  position: absolute;
  right: 0;
  // top: 50%;
  transform: translateY(-50%);
  margin-top: 10px;
  color: #3e63ee;
  padding: 2px 5px;
}

/*.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  color: #4d95fd;
  font-weight: bold;
}*/

/deep/ .course_name {
  font-size: 15px;
  display: inline-block;
  width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

}

::v-deep .level-1 {
  width: 340px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 15px !important;
  font-weight: 600;

}

::v-deep .level-2 {
  font-size: 14px !important;

  width: 320px !important;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
}

::v-deep .level-3 {
  font-size: 14px !important;

  width: 300px !important;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
}

::v-deep .level-4 {
  width: 280px !important;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
  font-size: 14px !important;

}

::v-deep .level-5 {
  width: 260px !important;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
  font-size: 14px !important;

}

::v-deep .level-6 {
  width: 240px !important;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
  font-size: 14px !important;

}

::v-deep .level-7 {
  width: 220px !important;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
  font-size: 14px !important;

}
</style>


